<div class="d-flex flex-column ">

  <p class="text-left titulo mt-4">Total de clientes <span class="total-clientes"> {{ totais.totalClientes}} </span></p>
  <div class="progress mt-3 mb-3">
    <div *ngIf="totais.totalClientesAtendidos" class="atendidos-bar" [ngStyle]="{'width': (totais.totalClientesAtendidos / totais.totalClientes) * 100 + '%' }"></div>
    <div *ngIf="totais.totalClientesAtendidos" class="space-prog"></div>
    <div *ngIf="totais.totalClientesNaoAtendidos" class="nao-atendidos-bar" [ngStyle]="{'width': (totais.totalClientesNaoAtendidos / totais.totalClientes) * 100 + '%' }" ></div>
    <div *ngIf="totais.totalClientesNaoAtendidos" class="space-prog"></div>
    <div *ngIf="totais.totalClientesAnalise" class="em-analise-bar" [ngStyle]="{'width': (totais.totalClientesAnalise / totais.totalClientes) * 100 + '%' }" ></div> 
    <div *ngIf="totais.totalClientesAnalise" class="space-prog"></div>
  </div>
  <div class="container">
    <div class="row mt-4">
      <div class="dados-status-entrega col-3 border-r-custom p-0" >
        <app-card-status-entregas corIndicador="#00B951" titulo="Atendidos" [valor]="totais.totalClientesAtendidos" [dados]="atendidos" ></app-card-status-entregas>
      </div>

      <div class="dados-status-entrega col-3 border-r-custom  p-0">
        <app-card-status-entregas corIndicador="#E53935" titulo="Não atendidos" [valor]="totais.totalClientesNaoAtendidos" [dados]="naoAtendidos" ></app-card-status-entregas>
      </div>

      <div class="dados-status-entrega col-3 border-r-custom  p-0">
        <app-card-status-entregas corIndicador="#FF9D43" titulo="Em análise" [valor]="totais.totalClientesAnalise"  [dados]="emAnalise"></app-card-status-entregas>
      </div>

      <div class="dados-status-entrega col-3  p-0" > 
        <app-card-status-entregas corIndicador="#C0C1C3" titulo="Pendentes" [valor]="totais.totalClientesNaoVisitados"  [dados]="pendentes" ></app-card-status-entregas>
      </div> 
    </div>
  </div>

</div>